<template>
  <BaseTable
    :key="selectedGroupItem?.id"
    :list="list"
    :headers="headers"
    :table-id="tableId"
    :total-records="totalRecords"
    :is-add-new-hidden="mode == 'view'"
    :hide-multiselect-delete="mode == 'view'"
    :items-per-page="itemsPerPage"
    :addButtonText="$t('common.actions.add')"
    :selected-page="1"
    hide-grouping
    is-download-button-hidden
    is-saving-layout-hidden
    @refresh-data="onRefreshGroupItemsTable"
    @add-new="emit('addNew')">
    <template #actions="{ item }" v-if="mode == 'edit'">
      <div class="flex items-center justify-center gap-1">
        <button
          v-if="item.isFromManager && !item.deleted"
          class="rounded-full p-1.5 text-red-400 hover:bg-red-50"
          type="button"
          @click="onDeleteRow(item)">
          <IconTrashOutline class="size-4" />
        </button>
      </div>
    </template>
  </BaseTable>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useGroupingStore } from '@/stores/grouping';

import BaseTable from '../common/BaseTable.vue';
import IconTrashOutline from '@/assets/icons/IconTrashOutline.vue';

import type { TableFilterData } from '@/types/Base';
import type {
  GroupItemAlterCode,
  GroupItemCustomer,
  GroupItemDetail,
  GroupItemMaterial,
  GroupItemTraderSite,
} from '@/types/Groups';

const { mode, groupItemsDetailsSelectedPage, selectedGroupItem } = storeToRefs(useGroupingStore());

defineProps<{
  list: GroupItemDetail[];
  totalRecords?: number;
  headers: any[];
  tableId: string;
}>();

const emit = defineEmits(['addNew', 'delete', 'refreshTable', 'deleteMultiselect']);

function onDeleteRow(
  item: GroupItemMaterial | GroupItemAlterCode | GroupItemCustomer | GroupItemTraderSite
) {
  emit('delete', item);
}
const itemsPerPage = ref(10);

async function onRefreshGroupItemsTable(data: TableFilterData) {
  groupItemsDetailsSelectedPage.value = data.page as number;
  emit('refreshTable', data);
}
</script>
